import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { IDashboardMidwifeResponse, IDashboardMumResponse, IPlace } from '../models/dashboard.models';
import { IGenericResponse } from '../models/shared.models';

@Injectable({
  providedIn: 'root'
})
export class EditProfileService {

  constructor(private http: HttpClient,
    private authService: AuthService) { }

  updateProfileDetailMidwife(body: any): Observable<IDashboardMidwifeResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}midwife/updateprofile`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IDashboardMidwifeResponse>(url, body, httpOptions);
  }

  updateProfileDetailMum(body: any): Observable<IDashboardMumResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}mum/updateprofile`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IDashboardMumResponse>(url, body, httpOptions);
  }

  updateProfileImageMidwife(body: any): Observable<IGenericResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}midwife/uploadphoto`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IGenericResponse>(url, body, httpOptions);
  }

  updateProfileImageMum(body: any): Observable<IGenericResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}mum/uploadphoto`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<IGenericResponse>(url, body, httpOptions);
  }

  getPlaceSearchResults(body: any): Observable<Array<IPlace>>{
    const url = `${environment.serverUrl}misc/predictions`;
    return this.http.post<Array<IPlace>>(url, body);
  }
}
